module.exports = __webpack_public_path__ + "media/icons/humidity-81ccb32273d13cc4c21bf79c93557eaa.svg";